/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
import { setError } from "redux-react/reducers/errorReducer";
import { display } from "redux-react/reducers/snackBarReducer";
import { api } from "./api";

const actions = {
	updateRule: (assistantID, code, rule, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/api/v1/rule/${assistantID}/${code}`,
					data: { rule },
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error?.message ?? "none"
							})
						);
					}
				})
			);
		};
	},
	updateSettings: (assistantID, collection, settings, id, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/api/v1/update/settings/${id}`,
					data: { collection, settings, assistantID },
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error?.message ?? "none"
							})
						);
					}
				})
			);
		};
	},
	updateAttributeDisplayPaginedList: (listCode, attributesList, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/api/v1/updateAttributeDisplayPaginedList/${listCode}`,
					data: { attributesList },
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error ?? "none"
							})
						);
					}
				})
			);
		};
	},
	getPageFiltersOld: (assistantID, code, route, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/filters/${assistantID}/${code}?isSystem=${route.system ?? false}`,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error?.message ?? "none"
							})
						);
					}
				})
			);
		};
	},
	getPageFilters: (assistantID, route, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/getFilters/${assistantID}`,
					data: {
						filterCode: route.filter ?? null, // filters v1
						filters: route.filters ?? [], // filters v2
						isSystem: route.system ?? false
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error?.message ?? "none"
							})
						);
					}
				})
			);
		};
	},
	getChartByCode: (assistantID, code, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/chart/${assistantID}/${code}`,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(setError(err.response?.data?.error ?? "none"));
					}
				})
			);
		};
	},
	refreshPaginedList: (
		list,
		entriesParPage,
		page,
		route,
		search,
		sort,
		filters,
		profileSystem,
		onSuccess
	) => {
		let data = {
			isSystem: route?.system ?? false,
			entriesParPage,
			page,
			search,
			request: list.request,
			filters,
			sort,
			profileSystem
		};
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/paginedList/pagination`,
					data,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(setError(err.response?.data?.error ?? "none"));
					}
				})
			);
		};
	},
	getPaginedList: (assistantID, route, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/paginedList/${assistantID}/${route.route.replace("/", "")}?isSystem=${route.system ?? false}`,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(setError(err.response?.data?.error ?? "none"));
					}
				})
			);
		};
	},
	getCharts: (assistantID, route, onSuccess) => {
		let data = {
			isSystem: route.system ?? false,
			filter: route.filter
		};
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/charts/${assistantID}/${route.route.replace("/", "")}`,
					data,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(setError(err.response?.data?.error ?? "none"));
					}
				})
			);
		};
	},
	buildRawCharts: (charts, filters, mandatoryFilters, onSuccess) => {
		let data = {
			charts,
			filters,
			mandatoryFilters: mandatoryFilters ?? []
		};

		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: "/api/v1/charts",
					data,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(setError(err.response?.data?.error ?? "none"));
					}
				})
			);
		};
	},
	getPageCharts: (assistantID, route, filters, mandatoryFilters, isPageSystem, onSuccess) => {
		let data = {
			filters,
			isSystem: isPageSystem,
			mandatoryFilters: mandatoryFilters ?? []
		};

		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/pageCharts/${assistantID}/${route.replace("/", "")}`,
					data,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error?.message ?? "none"
							})
						);
					}
				})
			);
		};
	},
	/* Get list count elements */
	getListCount: (assistantID, collection, filters, onSuccess, onFailure) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/list/count/${assistantID}/${collection}`,
					data: { filters },
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Fetch the full list data for a given chart code.
	 * @param {string} assistantID - The ID of the assistant owning the list.
	 * @param {string} code - The unique code identifying the list/chart.
	 * @param {boolean} isSystem - Whether the list is a system-level list.
	 * @param {Function} onSuccess - Callback invoked with the API response on success.
	 * @param {Function} onFailure - Callback invoked with the error on failure. Defaults to a no-op; callers are responsible for their own error UX.
	 * @returns {Function} A Redux thunk dispatching the API call.
	 * @example
	 * dispatch(ChartsActions.getListByCode(
	 *   profile.assistantID,
	 *   chart.code,
	 *   chart.isSystem,
	 *   res => console.log(res.paginedList?.data?.rows),
	 *   err => console.error(err)
	 * ));
	 */
	getListByCode: (assistantID, code, isSystem, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/list/${assistantID}/${code}`,
					data: {
						isSystem
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Fetch the full list data for a given chart code. Return only elements that have "display:true" in dictionary
	 * @param {string} assistantID - The ID of the assistant owning the list.
	 * @param {string} code - The unique code identifying the list/chart.
	 * @param {boolean} isSystem - Whether the list is a system-level list.
	 * @param {Function} onSuccess - Callback invoked with the API response on success.
	 * @param {Function} onFailure - Callback invoked with the error on failure. Defaults to a no-op; callers are responsible for their own error UX.
	 * @returns {Function} A Redux thunk dispatching the API call.
	 * @example
	 * dispatch(ChartsActions.getListByCode(
	 *   profile.assistantID,
	 *   chart.code,
	 *   chart.isSystem,
	 *   res => console.log(res.paginedList?.data?.rows),
	 *   err => console.error(err)
	 * ));
	 */
	getListByCodeWithDictionary: (assistantID, code, isSystem, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/listDictionary/${assistantID}/${code}`,
					data: {
						isSystem
					},
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
